export default {"src":"/_next/static/media/khcFavicon.53df9ba0.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};